import React from 'react'
import throttle from 'throttleit'

export interface ISize {
  width: number
  height: number
}

export const useWindowSize = (wait = 15) => {
  const [size, setSize] = React.useState<ISize>({
    width: 0,
    height: 0,
  })
  const setWindowSize = React.useCallback(() => {
    const { innerWidth: width, innerHeight: height } = window
    setSize({
      width,
      height,
    })
  }, [])
  React.useEffect(setWindowSize, [])
  const resizeHandler = React.useCallback(throttle(setWindowSize, wait), [wait])

  React.useEffect(() => {
    window.addEventListener('resize', resizeHandler)
    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])
  return size
}
